import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/dae0043ep053ijub1660";

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [tone, setTone] = useState<"idle" | "sending" | "ok" | "error">("idle");
  const [msg, setMsg] = useState("");

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setMsg("");
    const form = e.currentTarget;
    const data = new FormData(form);
    const hp = String(data.get("company_alt") || "").trim();
    if (hp) {
      setTone("ok");
      setMsg("订阅成功！重要瓜点的更新将第一时间送达你的邮箱。");
      return;
    }
    setTone("sending");
    const payload = new URLSearchParams();
    form.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>(
      "input[name], textarea[name], select[name]"
    ).forEach((el) => {
      if (el.name === "company_alt") return;
      const v = (el.value || "").trim();
      if (v) payload.append(el.name, v);
    });
    try {
      const res = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = null;
      }
      const meta = parsed && typeof parsed.meta === "object" ? (parsed.meta as Record<string, unknown>) : {};
      const serverMsg =
        (meta.message as string) || (parsed?.message as string) || (meta.detail as string) || text;
      if (res.ok && parsed && parsed.code === "OK") {
        setTone("ok");
        setMsg("订阅成功！重要瓜点的更新将第一时间送达你的邮箱。");
        setEmail("");
      } else if (serverMsg && String(serverMsg).toLowerCase().includes("spam")) {
        setTone("ok");
        setMsg("订阅成功！重要瓜点的更新将第一时间送达你的邮箱。");
      } else {
        setTone("error");
        setMsg(serverMsg || "订阅未成功，请稍后重试或更换邮箱。");
      }
    } catch {
      setTone("error");
      setMsg("网络异常，订阅未成功，请稍后再试。");
    }
  };

  const idle = tone === "idle";

  return (
    <section id="subscribe" className="relative overflow-hidden bg-background-50 py-14 md:py-20">
      <div
        className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-accent-500/15 blur-3xl"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-primary-500/15 blur-3xl"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-2xl bg-background-100 md:rounded-3xl">
          <div className="grid items-center gap-8 p-6 md:p-10 lg:grid-cols-2">
            <div>
              <h2 className="font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
                别错过下一口
                <br />
                新鲜的瓜
              </h2>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600 md:text-base">
                订阅爆炸瓜，重要事件每次发酵与反转的第一时间，我们都会把进展推送给你。
                免费订阅、随时退订，做一个永远赶在前的吃瓜人。
              </p>
              <ul className="mt-5 grid grid-cols-1 gap-2.5 text-sm text-foreground-700 sm:grid-cols-2">
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-primary-500" />
                  重点事件进展速递
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-primary-500" />
                  独家线索抢先看
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-primary-500" />
                  反转复盘周报
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-checkbox-circle-fill text-primary-500" />
                  随时可退订
                </li>
              </ul>
            </div>

            <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
              <form onSubmit={onSubmit} data-readdy-form="baozhagua-subscribe" className="flex flex-col gap-4">
                <div>
                  <label htmlFor="sub-email" className="mb-1.5 block text-sm font-bold text-foreground-900">
                    常用邮箱
                  </label>
                  <div className="relative">
                    <i className="ri-mail-line pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
                    <input
                      id="sub-email"
                      type="email"
                      name="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      className="w-full rounded-md border border-background-300 bg-background-50 py-3 pl-10 pr-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
                    />
                  </div>
                </div>
                <div>
                  <span className="mb-1.5 block text-sm font-bold text-foreground-900">订阅偏好</span>
                  <div className="flex flex-wrap gap-2">
                    {["吃瓜速递", "反转复盘", "深度追踪"].map((opt) => (
                      <label
                        key={opt}
                        className="inline-flex cursor-pointer items-center gap-1.5 rounded-full border border-background-300 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300"
                      >
                        <input type="checkbox" name="preference" value={opt} className="h-3.5 w-3.5 accent-[oklch(var(--primary-500))]" />
                        {opt}
                      </label>
                    ))}
                  </div>
                </div>
                <input
                  type="text"
                  name="company_alt"
                  className="hp-field"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  disabled={tone === "sending"}
                  className="mt-1 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60"
                >
                  {tone === "sending" ? "正在订阅…" : "立即订阅追瓜"}
                </button>
                {!idle && (
                  <p
                    className={`flex items-start gap-2 text-sm ${
                      tone === "error" ? "text-primary-700" : "text-secondary-700"
                    }`}
                    role="status"
                  >
                    <i className={`mt-0.5 ${tone === "error" ? "ri-error-warning-line" : "ri-checkbox-circle-line"}`} />
                    {msg}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}